import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ContractService } from '../../services/contract.service';

@Component({
  selector: 'app-new-user-creation-warning-dialog',
  templateUrl: './new-user-creation-warning-dialog.component.html',
  styleUrls: ['./new-user-creation-warning-dialog.component.scss']
})
export class NewUserCreationWarningDialogComponent implements OnInit {

  constructor(
    public dialoge:MatDialog,
    public dialogRef: MatDialogRef<NewUserCreationWarningDialogComponent>,
    public notifier: NotifierService,
    private router: Router,
    public contractService: ContractService,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close("cancelled");
  }

  onSubmit(){
    this.dialogRef.close("confirmed");
  }
}
